export default __webpack_public_path__ + "static/media/manali6.b539320a.webp";